import { RecordBase, registerInflection } from 'lib/record-base';

export class BodymatchedLeague extends RecordBase {
  static NAME = 'BodymatchedLeague';
}
registerInflection('bodymatchedLeague', 'bodymatchedLeagues', BodymatchedLeague);

